import { DeviceEnabledType, UserAttributeDefs } from '@iotv/datamodel-core'
import { Position } from '@iotv/iotv-v3-types'

const typeName = 'IsolationValve'

export type IsolationValveProps = {
  // state?: string;
  location?: Position
  image?: string
  valveState: boolean
}

export class IsolationValve extends DeviceEnabledType {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
    this.valveState = ob.valveState || false
  }

  // state?: string;
  location?: Position
  image?: string
  valveState: boolean

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of Valve',
      },
      state: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of Valve',
      },
      location: {
        type: 'object',
        editable: true,
        label: 'Location',
        name: 'location',
        description: 'Location of  Valve (lat/ long)',
      },
      valveState: {
        type: 'Boolean',
        editable: false,
        label: 'Active Valve',
        name: 'Active Valve',
        description: 'Is the valve active',
      },
      image: {
        type: 'String',
        editable: true,
        label: 'Image',
        name: 'image',
        description: 'Photograph of Valve',
      },
      comments: {
        type: 'String',
        editable: true,
        label: 'Comments',
        name: 'comments',
        description: 'Free text for info ',
      },
    }
  }
}
